module.exports = __webpack_public_path__ + "static/media/IMG_8011.c633b2f8.jpg";